<template>
  <div class="login-wrapper">
    <div class="login-left position-relative">
      <div class="main-side">
        <img src="../../assets/logo-kkp2.png" alt="Logo KKP" class="logo1" />
        <div></div>
        <img src="../../assets/logo-e-sea-black.png" alt="Logo E-Sea" class="logo2" />
        <h5>Sistem Pelaporan Tahunan</h5>
        <h5>Pengendalian Pemanfaatan Ruang Laut</h5>
      </div>
      <p class="position-absolute text-center w-100" style="bottom: 0px; left: 0px">
        &copy; {{ new Date().getFullYear() }} Kementerian Kelautan dan Perikanan RI.
      </p>
    </div>
    <div class="login-right">
      <div class="form-container">
        <h2 class="fw-bold">Register</h2>
        <p>Buat akun Anda untuk memulai menggunakan E-Sea</p>
        <form class="mt-4">
          <div class="form-group">
            <label class="form-label" for="npwp">NPWP</label>
            <input
              type="text"
              v-model="form.npwp"
              v-mask="'##.###.###.#-###.####'"
              class="form-control"
              id="npwp"
              placeholder="Masukkan NPWP Instansi/Perusahaan/Perorangan"
              name="NPWP"
              v-validate="'required|valid_npwp'"
            />
            <small class="text-danger" v-if="errors.has('NPWP')">
              {{ errors.first('NPWP') }}
            </small>
          </div>
          <div class="form-group">
            <label class="form-label" for="nama">Nama</label>
            <input
              type="text"
              v-model="form.nama"
              class="form-control"
              id="nama"
              placeholder="Masukkan Nama Instansi/Perusahaan/Perorangan"
              name="Nama"
              v-validate="'required'"
            />
            <small class="text-danger" v-if="errors.has('Nama')">
              {{ errors.first('Nama') }}
            </small>
          </div>
          <div class="form-group">
            <label class="form-label">Kategori Pengguna</label>
            <div>
              <div class="btn-group" role="group" aria-label="Radio button group">
                <input
                  type="radio"
                  class="btn-check"
                  name="Kategori Pengguna"
                  id="opt_pemerintah"
                  value="pemerintah"
                  v-model="form.tipe_pemohon"
                  autocomplete="off"
                  v-validate="'required'"
                />
                <label
                  class="btn btn-outline-success mb-0"
                  style="border-radius: 0.5rem 0rem 0rem 0.5rem"
                  for="opt_pemerintah"
                >
                  Pemerintah
                </label>
                <input
                  type="radio"
                  class="btn-check"
                  name="Kategori Pengguna"
                  id="opt_swasta"
                  value="swasta"
                  v-model="form.tipe_pemohon"
                  autocomplete="off"
                  v-validate="'required'"
                />
                <label class="btn btn-outline-success mb-0" for="opt_swasta">Swasta/Pelaku Usaha</label>
              </div>
            </div>
            <small class="text-danger" v-if="errors.has('Kategori Pengguna')">
              {{ errors.first('Kategori Pengguna') }}
            </small>
          </div>
          <div class="form-group">
            <label class="form-label" for="email">Email</label>
            <input
              type="text"
              v-model="form.email"
              class="form-control"
              id="email"
              placeholder="Masukkan email Instansi/Perusahaan/Perorangan"
              name="Email"
              v-validate="'required|email'"
              autocomplete="email"
            />
            <small class="text-danger" v-if="errors.has('Email')">
              {{ errors.first('Email') }}
            </small>
          </div>
          <div class="form-group">
            <label class="form-label" for="password">Password</label>
            <div class="input-group">
              <input
                :type="showPassword ? 'text' : 'password'"
                v-model="form.password"
                class="form-control"
                id="password"
                placeholder="Password"
                name="Password"
                v-validate="'required|strong_password'"
                autocomplete="new-password"
              />
              <button class="btn btn-outline-secondary" type="button" id="btn-show" @click="toggleShow">
                <i v-if="showPassword" class="bi bi-eye-slash"></i>
                <i v-else class="bi bi-eye"></i>
              </button>
            </div>
            <small class="text-danger" v-if="errors.has('Password')">
              {{ errors.first('Password') }}
            </small>
          </div>
          <VueRecaptcha
            @verify="markRecaptchaAsVerified"
            sitekey="6LcWcyopAAAAAMIHDH7BVEQuyt-Qw1T0C99UG6jz"
          ></VueRecaptcha>
          <strong>{{ pleaseTickRecaptchaMessage }}</strong>
          <div class="d-grid pt-3">
            <button type="button" class="btn btn-primary" @click="checkIfRecaptchaVerified" :disabled="isLoading">
              <template v-if="!isLoading">Register</template>
              <Loader v-else />
            </button>
          </div>
          <div class="text-center mt-3">
            <span>Anda sudah memiliki Akun?</span>
            <router-link to="/login" class="text-primary"> Login</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style src="./assets/css/hope-ui.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/pro.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/custom.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/dark.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/customizer.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/rtl.min.css?v=2.0.0" lang="css" />
<!-- Library Bundle Script -->
<script src="./assets/js/core/libs.min.js"></script>
<!-- Plugin Scripts -->
<!-- <style src="./assets/css/custom/login-custom.css" lang="css" /> -->
<!-- Slider-tab Script -->
<script src="./assets/js/plugins/slider-tabs.js"></script>
<!-- Lodash Utility -->
<script src="./assets/vendor/lodash/lodash.min.js"></script>
<!-- Utilities Functions -->
<script src="./assets/js/iqonic-script/utility.js"></script>
<!-- Settings Script -->
<script src="./assets/js/iqonic-script/setting.js"></script>
<!-- Settings Init Script -->
<script src="./assets/js/setting-init.js"></script>
<!-- External Library Bundle Script -->
<script src="./assets/js/core/external.min.js"></script>
<!-- Widgetchart Script -->
<script src="./assets/js/charts/widgetcharts.js?v=2.0.0" defer></script>
<!-- Dashboard Script -->
<script src="./assets/js/charts/dashboard.js?v=2.0.0" defer></script>
<script src="./assets/js/charts/alternate-dashboard.js?v=2.0.0" defer></script>
<!-- Hopeui Script -->
<script src="./assets/js/hope-ui.js?v=2.0.0" defer></script>
<script src="./assets/js/hope-uipro.js?v=2.0.0" defer></script>
<script src="./assets/js/sidebar.js?v=2.0.0" defer></script>

<script>
import { VueRecaptcha } from 'vue-recaptcha'
import { Validator } from 'vee-validate'
import axios from 'axios'
import Swal from 'sweetalert2'
import Loader from '../../components/Loader/Loader'

export default {
  components: { VueRecaptcha, Loader },
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      showPassword: false,
      form: {
        npwp: '',
        nama: '',
        tipe_pemohon: '',
        email: '',
        password: '',
        role: 'Pemrakarsa',
      },
      recaptchaVerified: false,
      pleaseTickRecaptchaMessage: '',
      isLoading: false,
    }
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword
    },
    markRecaptchaAsVerified() {
      this.pleaseTickRecaptchaMessage = ''
      this.recaptchaVerified = true
    },
    async checkIfRecaptchaVerified() {
      await this.$validator.validateAll()
      if (this.$validator.errors.any()) return

      if (!this.recaptchaVerified) {
        this.pleaseTickRecaptchaMessage = 'Please tick recaptcha.'
        return true
      }
      this.register()
    },
    async register() {
      try {
        this.isLoading = true
        const res = await axios.post(`${this.baseapiPengendalian}api/auth/signup`, this.form)
        await Swal.fire('Berhasil', res.data.message, 'success')
        this.$router.push('/login')
      } catch (error) {
        if (error.status >= 500) {
          Swal.fire('Error', 'Sedang terjadi kendala pada Server', 'error')
        } else {
          Swal.fire('Register Gagal', error.response?.data?.message || 'Terjadi kesalahan saat register', 'warning')
        }
      } finally {
        this.isLoading = false
      }
    },
  },
  mounted() {
    const dictionary = {
      id: {
        messages: {
          required: (fieldName) => `${fieldName} wajib diisi`,
          email: (fieldName) => `Format email tidak sesuai`,
          strong_password: (fieldName) =>
            `${fieldName} harus memiliki minimal 8 karakter, termasuk huruf besar, huruf kecil, angka, dan simbol.`,
          valid_npwp: (fieldName) => `Format NPWP tidak sesuai`,
        },
      },
    }
    Validator.localize(dictionary)
    this.$validator.localize('id')
  },
  created() {
    Validator.extend('strong_password', {
      validate: (value) => {
        return (
          /[A-Z]/.test(value) &&
          /[a-z]/.test(value) &&
          /[0-9]/.test(value) &&
          /[^A-Za-z0-9]/.test(value) &&
          value.length >= 8
        )
      },
    })
    Validator.extend('valid_npwp', {
      validate: (value) => {
        return /^\d{2}\.\d{3}\.\d{3}\.\d-\d{3}\.\d{3,4}$/.test(value)
      },
    })
  },
}
</script>

<style scoped>
.login-wrapper {
  display: flex;
  height: 100vh;
  overflow: hidden;
}

.login-left {
  flex: 1;
  max-width: 700px;
  background: #ffffff;
  /* background: linear-gradient(0deg, rgba(0, 0, 84, 1) 0%, rgba(0, 212, 255, 1) 100%); */
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 60px 60px;
  box-shadow: -5px 0 25px rgba(0, 0, 0, 0.05);
  z-index: 2;
}

.main-side {
  text-align: center;
  padding-bottom: 60px;
}

.main-side .logo1 {
  height: 140px;
  object-fit: contain;
  margin-bottom: 30px;
}

.main-side .logo2 {
  height: 100px;
  object-fit: contain;
  margin-bottom: 30px;
}

.login-right {
  flex: 2;
  background: url('../../assets/login-img.jpg') no-repeat center center;
  background-size: cover;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
}

.form-container {
  width: 500px;
  background: #ffffff;
  position: relative;
  z-index: 2;
  padding: 20px;
  border-radius: 5px;
}

.form-container .main-side {
  display: none;
}

.login-right::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
}

.login-left h4 {
  font-weight: 600;
  font-size: 1.8rem;
  margin-bottom: 10px;
  color: #212529;
}

.login-left p {
  color: #6c757d;
  font-size: 1rem;
  margin-bottom: 35px;
}

@media (max-width: 992px), (max-height: 700px) {
  .login-wrapper {
    display: block;
    /* justify-content: center; */
    /* align-items: center; */
    background: url('../../assets/login-img.jpg') no-repeat center center fixed;
    background-size: cover;
    height: auto;
    /* padding: 40px 20px; */
  }

  .login-left {
    /* display: none; */
    display: block;
    max-width: 100%;
    padding: 20px;
  }

  .login-right {
    /* display: block; */
    background: transparent;
    border-radius: 5px;
    width: 100%;
    margin: 100px 0px;
  }

  .login-right::after {
    display: none;
  }

  .main-side .logo1 {
    height: 70px;
    object-fit: contain;
    margin-bottom: 10px;
  }

  .main-side .logo2 {
    height: 50px;
    object-fit: contain;
  }

  .form-container .main-side {
    display: block;
  }
}
</style>
